export interface ActivationCorrelation {
  readonly task_id: string
  readonly session_id?: string
  readonly environment_id?: string
  readonly activation_trace_id: string
  readonly activation_sequence?: string
  readonly activation_source?: 'connect' | 'reconnect' | 'unknown'
}

const MAX_ACTIVATION_CORRELATIONS = 512
const correlationsByTask = new Map<string, ActivationCorrelation>()

export function recordActivationCorrelation(correlation: ActivationCorrelation): void {
  correlationsByTask.delete(correlation.task_id)
  correlationsByTask.set(correlation.task_id, correlation)

  while (correlationsByTask.size > MAX_ACTIVATION_CORRELATIONS) {
    const oldestTaskId = correlationsByTask.keys().next().value
    if (!oldestTaskId) break
    correlationsByTask.delete(oldestTaskId)
  }
}

export function getActivationCorrelation(taskId: string | undefined): ActivationCorrelation | undefined {
  return taskId ? correlationsByTask.get(taskId) : undefined
}

export function clearActivationCorrelations(): void {
  correlationsByTask.clear()
}
